import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { UPDATE_OPEN_ORDERS_FORM_NAME } from 'Common/FormEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import { UpdateOpenOrdersEnum } from 'Common/FieldEnum';
import { errorToast } from 'Common/ToastHelper';
import { createToast, toastType } from 'Common/ToastHelper';
import { NotificationDialog, LoadingPage } from 'Components';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { resetDirty } from 'State/dirtyTracking/actions';
import { OrderTypeEnum } from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';

import { UpdateOpenOrderDetails } from './UpdateOpenOrderDetails';
import {
  getSaveObject,
  getSiteGroupOptionsData,
} from '../../helper/updateOpenOrders';
import { actions } from '../../state/actions';
import * as Selectors from './../../state/updateopenorders/selectors';

class UpdateOpenOrderDetailContainer extends Component {
  static path = '/openorders';

  static propTypes = {
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    getSiteGroupData: PropTypes.func.isRequired,
    getWarehouseKitchenData: PropTypes.func.isRequired,
    getItemList: PropTypes.func.isRequired,
    changeDropDownData: PropTypes.func.isRequired,
    saveUpdateOrder: PropTypes.func.isRequired,

    openOrderDetailData: PropTypes.array.isRequired,
    submitted: PropTypes.bool.isRequired,
    updateOrderResponseError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    siteGroupData: PropTypes.array.isRequired,
    warehouseKitchenData: PropTypes.array.isRequired,
    fetchingSiteGroupError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    warehouseKitchenDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    itemListError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    updateOrderResponseError: null,
    fetchingSiteGroupError: null,
    warehouseKitchenDataError: null,
    itemListError: null,
  };

  reactTableRef = React.createRef();
  state = {
    showNoDataModal: false,
    checkEmptyQty: false,
  };

  async componentDidMount() {
    const {
      getSiteGroupData,
      getWarehouseKitchenData,
      getItemList,
      resetDirty,
    } = this.props;

    await getSiteGroupData();
    const siteGroupsOptions = getSiteGroupOptionsData(this.props.siteGroupData);
    siteGroupsOptions.length &&
      this.props.changeDropDownData(
        UpdateOpenOrdersEnum.SiteGroup,
        siteGroupsOptions[0].value
      );
    getItemList(
      moment().format(DATE_FORMAT_FOR_SERVER),
      OrderTypeEnum.OpenOrder
    );
    await getWarehouseKitchenData();
    const warehouseOptions = makeOptionsDataRemoveEmpty(
      this.props.warehouseKitchenData
    );
    warehouseOptions.length &&
      this.props.changeDropDownData(
        UpdateOpenOrdersEnum.WarehouseKitchen,
        warehouseOptions[0].value
      );
    const kitchenOptions = makeOptionsDataRemoveEmpty(this.props.kitchenData);
    kitchenOptions.length &&
      this.props.changeDropDownData(
        UpdateOpenOrdersEnum.Kitchen,
        kitchenOptions[0].value
      );
    resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearError } = this.props;
    if (
      errorToast(this.props, prevProps, 'updateOrderResponseError') ||
      errorToast(this.props, prevProps, 'fetchingSiteGroupError') ||
      errorToast(this.props, prevProps, 'warehouseKitchenDataError') ||
      errorToast(this.props, prevProps, 'itemListError')
    ) {
      clearError();
    }
    if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Order(s) has been updated.',
        true
      );
      clearError();
      this.completeReset();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Update Selected',
            onClick: this.handleSave,
            disabled: false,
          },
        ],
        shown: true,
      },
    };
  };

  handleSave = () => {
    this.props.submitForm(UPDATE_OPEN_ORDERS_FORM_NAME);
  };

  handleSubmit = values => {
    const filteredData = _.filter(
      this.props.openOrderDetailData,
      UpdateOpenOrdersEnum.Allowed
    );
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: filteredData };
    let data = [];
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj.OrderNumber ? obj.OrderNumber : obj._original.OrderNumber;
      const row = _.find(filteredData, v => v.OrderNumber === id);
      if (row) {
        data.push(row);
      }
    });
    if (data.length) {
      const dataHasNull = data.some(item => {
        if (
          (values[UpdateOpenOrdersEnum.AddItemListData] &&
            (!item.AddQtyPrimary && !item.AddQtySecondary)) ||
          item.AddQtyPrimary === GenericEnum.EmptyString ||
          item.AddQtyPrimary === GenericEnum.ZeroString ||
          (item.AddQtySecondary === GenericEnum.EmptyString ||
            item.AddQtySecondary === GenericEnum.ZeroString)
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (dataHasNull) {
        this.setState({ checkEmptyQty: true });
        return;
      } else {
        this.props.saveUpdateOrder(getSaveObject(values, data));
      }
    } else {
      this.setState({
        showNoDataModal: true,
      });
      return;
    }
    this.resetScroll();
    this.props.resetDirty();
    this.props.history.push('/openorders');
  };

  completeReset = () => {
    this.props.resetForm(UPDATE_OPEN_ORDERS_FORM_NAME);
  };

  handleNoDataDialog = () => {
    this.setState({ showNoDataModal: false });
  };

  handleCheckEmptyQty = () => {
    this.setState({ checkEmptyQty: false });
  };
  resetScroll = () => this.props.scrollMainTo(0, 0);

  render() {
    return (
      <Fragment>
        {this.props.submitting && <LoadingPage />}
        <Filter title={'Utilities - Update Open Orders/Receipts'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <UpdateOpenOrderDetails
            onSubmit={this.handleSubmit}
            reactTableRef={this.reactTableRef}
          />
          <NotificationDialog
            title={'Update Open Orders/Receipts'}
            showDialog={this.state.showNoDataModal}
            message={'Please select at least one order/receipt to update.'}
            onOkClick={this.handleNoDataDialog}
          />
          <NotificationDialog
            title={'Update Open Orders/Receipts'}
            showDialog={this.state.checkEmptyQty}
            message={
              'One or more selected orders/receipts have no values in the Add Qty columns.'
            }
            onOkClick={this.handleCheckEmptyQty}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(UPDATE_OPEN_ORDERS_FORM_NAME)(state));

  return {
    openOrderDetailData: Selectors.getOpenOrderDetailData(state),
    submitted: Selectors.getSubmitted(state),
    updateOrderResponseError: Selectors.getUpdateOrderResponseError(state),
    siteGroupData: Selectors.getSiteGroup(state),
    warehouseKitchenData: Selectors.getWarehouseKitchen(state),
    fetchingSiteGroupError: Selectors.getSiteGroupError(state),
    warehouseKitchenDataError: Selectors.getWarehouseKitchenDataError(state),
    itemListError: Selectors.getItemListError(state),
    kitchenData: Selectors.getKitchenData(state),
    submitting: Selectors.getSubmitting(state),
  };
};

export const UpdateOpenOrder = connect(
  mapStateToProps,
  {
    ...actions,
    submitForm,
    resetForm,
    resetDirty,
  }
)(UpdateOpenOrderDetailContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/updateopenorders/containers/UpdateOpenOrderDetailContainer.js